var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorQuoteRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.78 11.7125C10.6922 12.5269 9.36761 12.978 8 13C3.54545 13 1 8.00001 1 8.00001C1.79157 6.55119 2.88945 5.28539 4.22 4.28751M6.66364 3.15002C7.10167 3.04932 7.55013 2.99898 8 3.00002C12.4545 3.00002 15 8.00001 15 8.00001C14.6137 8.70976 14.153 9.37797 13.6255 9.99375M9.34909 9.32501C9.17431 9.50922 8.96355 9.65698 8.72937 9.75946C8.49519 9.86194 8.24239 9.91704 7.98606 9.92148C7.72972 9.92593 7.4751 9.87961 7.23739 9.78531C6.99967 9.69101 6.78373 9.55065 6.60245 9.3726C6.42116 9.19456 6.27825 8.98247 6.18223 8.749C6.08622 8.51553 6.03906 8.26546 6.04358 8.0137C6.04811 7.76194 6.10421 7.51366 6.20856 7.28366C6.3129 7.05367 6.46334 6.84667 6.65091 6.67501",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L14 14",
    stroke: "#364863",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorQuoteRead);
export default __webpack_public_path__ + "static/media/icon-indicator-quote-read.9927aee6aa24fd56db112726f7ac87c2.svg";
export { ForwardRef as ReactComponent };